module.exports = __webpack_public_path__ + "Roboto-Thin.1f35e6a11d27d2e10d28.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Thin.woff2
// module id = 614
// module chunks = 2